import { render } from "./LbrxListWebOrders.vue?vue&type=template&id=5cda4ca0"
import script from "./LbrxListWebOrders.vue?vue&type=script&lang=js"
export * from "./LbrxListWebOrders.vue?vue&type=script&lang=js"

import "./LbrxListWebOrders.vue?vue&type=style&index=0&id=5cda4ca0&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__